<template>
  <div id="permissions">
    <el-container>
      <el-header>
        <top-Nav></top-Nav>
      </el-header>
      <el-main>
        <el-row>
          <div style="height:56px;background:#ccc">
            <div class="mainHead">
              <div class="route">
                <span class="crumbs"></span><span>权限管理</span><span class="arrow">></span><span>授权用户</span><span></span>
              </div>
              <div>
                <el-button type="primary" @click="savePerssionId">保存</el-button>
                <el-button type="primary" @click="returnList">返回</el-button>
              </div>
            </div>
          </div>
          <div class="permissions-content">
            <div class="permissions-left inline" v-if="isAuth('common:interface')" @mousemove="mousearch">
              <!--<el-input placeholder="搜索角色名称" v-model="roleList.searname" clearable @clear="clearableBack" ref="inputRef" @blur="searchBlur()"></el-input>-->
              <i></i>
              <el-input v-model="leftSelect.searname" placeholder="搜索用户名称、工号" @blur="searchRole" clearable @clear="clearableBack" ref="inputRef"></el-input>
              <div class="permissions-left_list">
                <ul>
                  <li v-for="(item,index) in leftData" :key="index" class="role_list" :class="{check:item.checked}" @click.stop="selectRoleList(item)">{{item.userName}}<span>|</span>{{item.userNumber}}</li>
                </ul>
              </div>
            </div>
            <div class="permissions-right inline">
              <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
                <el-tab-pane label="功能权限" name="first">
                  <div class="user_name">
                    用户角色： <el-select v-model="value" multiple placeholder="请选择" @change="getUserSelectId" :disabled="!isAuth('common:interface')">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  </div>
                  <div class="table" :style="{maxHeight:treeScreenHeight+'px'}">
                    <div v-if="isAuth('common:interface')">
                      <el-tree
                        :data="treeData"
                        ref="firstTree"
                        show-checkbox
                        node-key="id"
                        @check="checkRoleId"
                        :default-expanded-keys="checkId"
                        :default-checked-keys="checkId"
                        :props="defaultProps"
                      >
                      </el-tree>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="数据权限" name="second">
                  <div class="user_name"></div>
                  <div class="table" :style="{maxHeight:treeScreenHeight+'px'}">
                    <!--<el-tree-->
                      <!--:data="basicTreeData"-->
                      <!--ref="tree"-->
                      <!--show-checkbox-->
                      <!--:filter-node-method="filterNode"-->
                      <!--node-key="id"-->
                      <!--:expand-on-click-node="false"-->
                      <!--:default-expanded-keys="checkId"-->
                      <!--:default-checked-keys="checkId"-->
                      <!--:props="defaultProps" @node-click="handleNodeClick"-->
                    <!--&gt;-->
                    <!--</el-tree>-->
                    <el-tree
                      :data="functionData"
                      show-checkbox
                      ref="thirdTree"
                      :default-expanded-keys="treeListId"
                      node-key="id"
                      @check="getMonitorId"
                      :props="defaultProps1"
                    >
                    </el-tree>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import topNav from '../../components/TopNav.vue';
  import {ajaxFuncJson} from "../../api/ajax";

  export default {
    name: 'permissions',
    data() {
      return {
        activeName: 'first',
        input: '',
        checked: '',
        obj: {},
        leftSelect:{
          searname:''
        },
        leftData:[],    //左侧数据
        roleId:'',
        value:[],
        options: [],
        userName:'',
        treeData:[],
        basicTreeData:[],   //当没有选择用户时禁用权限勾选
        checkId:[],
        treeListId:[],
        treeScreenHeight:'',
        dialogVisible:false,
        defaultProps: {
          children:'list',
          label:'menuName',
          disabled:'enabled'
        },
        functionData:[],
        defaultProps1:{
          children:'children',
          label:'label',
        },
        basicSelectId:[],       //获取勾选的id(不包括以前勾选的)
        allSelectId:[],       //获取勾选的id(包括以前勾选的)含父节点
        selectMenuId:'',      //选中的二级目录id
        allSelectMonitorId:[],   //选择的监测点id
        isChangeFunctionTree:[],    //判断修改了权限列表
        isChangeDataTree:[],       //判断是否修改了数据列表
        target:0,
        windowResize:null,
        isClickSave:false,
        paramsData:{
          userId:'',
          builIds:{
            customerId:[],
            buildId:[],
            floorId:[],
            monitoringId:[]
          },
        },
      }
    },
    created(){
      this.roleId=this.$route.query.id;
      if(this.isAuth('common:interface')){
        this.getAllRole();
      }
      if(this.isAuth('common:interface')){
        this.getAllUser();
      }
      this.listenKeyDown();
    },
    computed:{

    },
    mounted() {
      let that = this;
      that.windowResize= function () {
        that.treeScreenHeight=$('.permissions-right').height()-52-$('.user_name').height();
      };
      that.windowResize();
      window.addEventListener('resize',that.windowResize);
    },
    methods: {
      //保存权限
      savePerssionId(){
        if(this.value.length===0){
          this.$message({
            message:'用户角色不能为空',
            type:'warning'
          })
        }else {
          if(this.activeName==='first'){
            this.bindFunctionAjax();
          }else {
            this.bindMonitorAjax();
          }
        }
        // this.$router.push({path:'/permissions',query:{id:this.roleId}});
      },
      //获取选择的监测点的所有id
      getMonitorId(row,rows){
        // type 1 建筑  type 2 栋 type 3楼层  null监测点
        // this.allSelectMonitorId=rows.checkedKeys.concat(rows.halfCheckedKeys);     //勾选包含父元素暂时废弃
        this.allSelectMonitorId=rows.checkedKeys;
        this.isClickSave=false;
        if(this.isChangeDataTree.indexOf(row.id)===-1){
          this.isChangeDataTree.push(row.id);
        }else {
          this.isChangeDataTree.splice(this.isChangeDataTree.indexOf(row.id),1);
        }
      },
      //绑定监测id权限
      bindMonitorAjax(){
        let params={
          userId:this.roleId,
          builIds:this.allSelectMonitorId,
        };
        ajaxFuncJson('/userMonitoring/binUserMonitor',params).then(res=>{
          if(res.data.status==200){
            this.dialogVisible=false;
            this.isClickSave=true;
            this.$alert('保存成功', '提示', {
              confirmButtonText: '我知道了',
              callback: action => {
                this.getAllRole();
                this.isClickSave=true;
              }
            });
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        });
      },
      //绑定功能权限
      bindFunctionAjax(){
        let params={
          userId:this.roleId,
          ments:this.allSelectId,
          roleIds:this.value,
        };
        ajaxFuncJson('/roles/updateUserMenu',params).then(res=>{
          if(res.data.status==200){
            this.$alert('保存成功', '提示', {
              confirmButtonText: '我知道了',
              callback: action => {
                this.getAllRole();
                this.isClickSave=true;
                this.activeName='first';
              }
            });
          }else {
            this.$message({
              message:res.data.msg,
              type:'error',
            })
          }
        });
      },
      getUserSelectId(){
        this.getUserSelectIdAjax();
      },
      //切换tab
      changeTab(){
        if(this.activeName==='second'){
          if(this.basicSelectId.length>0){
            this.basicSelectId.forEach((id,item)=>{
              if(this.checkId.indexOf(id)===-1){
                this.checkId.push(id);
              }
            });
          }
          this.getSetPermissionId();
        }else {

        }
      },
      //勾选角色id
      checkRoleId(row,rows){
          if(this.basicSelectId.indexOf(row.id)===-1){
            this.basicSelectId.push(row.id);
          }else {
            this.basicSelectId.splice(this.basicSelectId.indexOf(row.id),1);
          }
          this.allSelectId=rows.checkedKeys.concat(rows.halfCheckedKeys);
          this.checkId=rows.checkedKeys;
        this.isClickSave=false;
        if(this.isChangeFunctionTree.indexOf(row.id)===-1){
          this.isChangeFunctionTree.push(row.id);
        }else {
          this.isChangeFunctionTree.splice(this.isChangeFunctionTree.indexOf(row.id),1);
        }
      },
      //获取权限后续勾选的内容
      getUserLastChecked(){
        let params={
          userId:this.roleId,
        };
        ajaxFuncJson('/roles/findUserRoles',params).then(res=>{
          if(res.data.status ==200){
            let newArr=[];
            if(res.data.data.length>0){
              res.data.data.forEach((item,index)=>{
                this.checkBasicId(String(item),this.treeData,newArr);
              })
            }
            this.basicSelectId=newArr;
            this.getUserSelectIdAjax();
          }else {
            this.$message({
              message:res.data.msg,
              type:'error',
            })
          }
        });
      },
      //更新数据时的树形显示 （去掉半选状态id避免视图半选状态id下全选）
      checkBasicId(id,data,newArr){
        data.forEach((item,index) => {
          if(item.id == id){
            if( !item.list||item.list.length == 0 ){
              newArr.push(item.id)
            }
          }else{
            if(item.list){
              if( item.list.length !=0 ){
                this.checkBasicId(id,item.list,newArr)
              }
            }
          }
        });
      },
      //获取选择用户的权限并选中权限不可取消
      getUserSelectIdAjax(){
        let params={
          roleIds:this.value,
        };
        ajaxFuncJson('/roles//findRolesById',params).then(res=>{
          if(res.data.status==200){
            this.checkId=[];
            let newArr=[];
            if(res.data.data.length>0){
              res.data.data.forEach((id,index)=>{
                this.checkBasicId(String(id),this.treeData,newArr)
              });
              this.checkId=newArr;
            }
            if(this.value.length>0){
                this.treeData.forEach((firstList,firstIndex)=>{
                  if(this.checkId.indexOf(firstList.id)===-1){
                    this.treeData[firstIndex].enabled=false;
                  }else {
                    this.treeData[firstIndex].enabled=true;
                  }
                  if(firstList.list&&firstList.list.length>0){
                    firstList.list.forEach((secondList,secondIndex)=>{
                      if(this.checkId.indexOf(secondList.id)===-1){
                        this.treeData[firstIndex].list[secondIndex].enabled=false;
                      }else {
                        this.treeData[firstIndex].list[secondIndex].enabled=true;
                      }
                      if(secondList.list&&secondList.list.length>0){
                        secondList.list.forEach((thirdList,thirdIndex)=>{
                          if(this.checkId.indexOf(thirdList.id)===-1){
                            this.treeData[firstIndex].list[secondIndex].list[thirdIndex].enabled=false;
                          }else {
                            this.treeData[firstIndex].list[secondIndex].list[thirdIndex].enabled=true;
                          }
                          if(thirdList.list&&thirdList.list.length>0){
                            thirdList.list.forEach((fourList,fourIndex)=>{
                              if(this.checkId.indexOf(fourList.id===-1)){
                                this.treeData[firstIndex].list[secondIndex].list[thirdIndex].list[fourIndex].enabled=false;
                              }else {
                                this.treeData[firstIndex].list[secondIndex].list[thirdIndex].list[fourIndex].enabled=true;
                              }
                            })
                          }
                        });
                      }
                    })
                  }
                });
            }else {
              this.treeData=JSON.parse(JSON.stringify(this.basicTreeData));
              this.basicSelectId=[];
            }
            if(this.basicSelectId.length>0){
              this.basicSelectId.forEach((id,index)=>{
                if(this.checkId.indexOf(id)===-1){
                  this.checkId.push(id);
                }
              })
            }
            this.$nextTick(() => {
              this.$refs.firstTree.setCheckedKeys(this.checkId);
            });


          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        })
      },
      returnList(){
        if(this.isClickSave){
          this.$router.push({path:'/permissionManger'});
        }else {
          if(this.isChangeDataTree.length>0||this.isChangeFunctionTree.length>0){
            this.$confirm('离开将无法保存已修改信息！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(() => {
              this.$router.push({path:'/permissionManger'});
            }).catch(() => {

            });
          }else {
            this.$router.push({path:'/permissionManger'});
          }
        }
      },
      //搜索用户
      searchRole(){
        if(this.target==1){
          this.leftSelect.searname= '';
          this.$refs.inputRef.$el.children[0].focus();
          this.target = 0
        }else {
          this.getAllRole();
        }
      },
      //监听enter键
      listenKeyDown(){
        let _this=this;
        document.onkeydown=function(event){
          var e = event || window.event || arguments.callee.caller.arguments[0];
          if(e && e.keyCode==13){//上,左
            _this.getAllRole();
          }
        };
      },
      mousearch(event){
        if(event.target.className == "el-input__icon el-icon-circle-close el-input__clear"){
          this.target = 1;
        }else{
          this.target = 0
        }
      },
      //搜索角色名称 - 清除回调
      clearableBack() {
        this.$refs.inputRef.$el.children[0].focus();
      },
      //获取所有的角色
      getAllUser(){
        ajaxFuncJson('/roles/finAllRolesByCusId','').then(res=>{
          if(res.data.status==200){
              this.options=res.data.data;
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        })
      },
      getAllRole(){
        ajaxFuncJson('/users/findUserAndNum',this.leftSelect).then(res=>{
          if(res.data.status==200){
            this.value=[];
            this.leftData=res.data.data;
            if(this.leftData.length>0){
              this.leftData.forEach((item,index)=>{
                this.$set(item,'checked',false);
                if(item.id==this.roleId){
                  this.leftData[index].checked=true;
                  if(item.rolename&&item.rolename.length>0){
                    item.rolename.forEach((items,indexs)=>{
                      this.value.push(items.id);
                    })
                  }
                }
              });
              this.getDataTree();
              this.getFunctionTree();
            }else {
              this.treeData=[];
              this.basicTreeData=[];
            }
          }else {
            this.$message({
              message:res.data.msg,
              type:'error',
            })
          }
        });
      },
      //获取设置监测点id
      getSetPermissionId(){
        let params={
          userId:this.roleId,
        };
        ajaxFuncJson('/userMonitoring/findUserMonitor',params).then(res=>{
          if(res.data.status==200){
            this.treeListId=[];
            if(res.data.data.length>0){
              res.data.data.forEach((idList,index)=>{
                this.treeListId.push(idList.monitoringId);
              });
            }
            this.$nextTick(()=>{
              this.$refs.thirdTree.setCheckedKeys(this.treeListId);
            });
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        })
      },
      //筛选勾选的树形图
      filterNode(value, data) {
        if (!value) return true;
        return value.indexOf(data.id)!== -1;
      },
      //点击左侧用户和工号
      selectRoleList(list){
        this.value=[];
        this.leftData.forEach((item,index)=>{
          if(list.id==item.id){
            this.leftData[index].checked=true;
            this.roleId=list.id;
            if(item.rolename&&item.rolename.length>0){
              item.rolename.forEach((items,indexs)=>{
                this.value.push(items.id);
              })
            }
            this.getDataTree();
            this.getFunctionTree();
            this.activeName='first';
            // this.getUserLastChecked();
          }else {
            this.leftData[index].checked=false;
          }
        });
      },
      //获取权限的数据
      getDataTree(){
        let params={
          id:this.roleId,
        };
        ajaxFuncJson('/menu/tree/list',params).then(res=>{
          if(res.data.status==200){
            this.treeData=res.data.data.menuList;
            this.basicTreeData=JSON.parse(JSON.stringify(res.data.data.menuList));
            this.getUserLastChecked();
          }else {
            this.$message({
              message:res.data.msg,
              type:'error',
            })
          }
        });
      },
      //获取数据权限的数据
      getFunctionTree(){
        let params={
          id:this.roleId,
        };
        ajaxFuncJson('/menu/getDateAuthorityTree',params).then(res=>{
          if(res.data.status==200){
            this.functionData=res.data.data;
            this.functionData.forEach((item,index)=>{
              if(item.children.length>0&&item.children){
                item.children.forEach((items,indexes)=>{
                  if(items.children.length>0&&items.children){
                    items.children.forEach((thirdItem,thirdIndex)=>{
                      if(String(thirdItem.label).indexOf('-')!=-1){
                        this.functionData[index].children[indexes].children[thirdIndex].label=String(thirdItem.label).replace('-','B');
                      }else if(String(thirdItem.label).indexOf('待标注')!=-1){
                        this.functionData[index].children[indexes].children[thirdIndex].label=thirdItem.label;
                      }else {
                        this.functionData[index].children[indexes].children[thirdIndex].label='L'+thirdItem.label;
                      }
                    })
                  }
                })
              }
            });
            this.getSetPermissionId();
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        });
      },
    },
    destroyed(){
      let _this=this;
      window.removeEventListener("resize",_this.windowResize)
    },
    components: {
      topNav,
    }
  }
</script>

<style lang="scss" scope>
  #permissions {
    height: 100%;
    .el-container {
      height: 100%;
      .el-main {
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        padding: 0 20px 10px 20px;
        background: #f2f2f2;
        .el-row {
          background: #fff;
          height: 100%;
          .mainHead{
            margin-right: 0;
          }
          .permissions-content {
            .inline {
              float: left;
            }
            margin-top: 20px;
            height: calc(100% - 77px);
            .permissions-left {
              width: 394px;
              margin-left: 40px;
              height: calc(100% - 20px);
              position: relative;
              >i {
                position: absolute;
                top: 12px;
                left: 10px;
                width: 16px;
                height: 16px;
                background: url("../../assets/img/search2.png");
                cursor: pointer;
                z-index: 1;
              }
              .permissions-left_list {
                height: calc(100% - 32px);
                overflow: hidden;
                overflow-y: auto;
                border: 1px solid #e0e0e0;
                border-top: none;
                .role_list{
                  padding-left: 20px;
                  font-size: 13px;
                  color: #282828;
                  cursor: pointer;
                  span{
                    padding: 0 10px;
                  }
                }
                .check{
                  color: #198cff;
                  background: #F5F5F5;
                }
              }
              .permissions-left_list::-webkit-scrollbar {/*滚动条整体样式*/
                width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
                height: 1px;
              }
              .permissions-left_list::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                border-radius: 2px;
                -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
                background: #dddddd;
              }
              .permissions-left_list::-webkit-scrollbar-track {/*滚动条里面轨道*/
                -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
                border-radius: 2px;
                background: #f5f5f5;
              }
              .el-input .el-input__inner{
                width: 100% !important;
                padding-left: 30px!important;
                height: 40px;
              }
              .permissions-left_list {
                li {
                  height: 35px;
                  list-style: none;
                  line-height: 35px;
                  border-bottom: 1px solid #f5f5f5;
                }
                li:hover {
                  background: #f5f5f5;
                }
              }
            }
            .permissions-right {
              height: calc(100% - 20px);
              margin-left: 40px;
              width: calc(100% - 474px);
              .el-tabs--card > .el-tabs__header {
                height: 32px;
              }
              .el-tabs__content {
                margin-top: 20px;
              }
              .el-tabs--card > .el-tabs__header .el-tabs__nav {
                border-radius: 0;
                z-index: 0;
              }
              .el-tabs--card > .el-tabs__header .el-tabs__item {
                width: 80px;
                height: 30px;
                line-height: 30px;
                margin-right: -1px;
                font-size: 13px;
                border: 1px solid #e0e0e0;
              }
              .el-tabs--card > .el-tabs__header .el-tabs__item:hover{
                border:1px solid  #198cff;
              }
              .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
                background: #198cff;
                border:1px solid  #198cff;
                color: #ffffff;
                border-bottom-color: transparent;
                margin-bottom: 0;
              }
              .table {
                padding-right: 20px;
                padding-top: 10px;
                overflow: auto;
                .el-tree{
                  .el-checkbox__input{
                    z-index: 0;
                  }
                }
              }
              .table::-webkit-scrollbar {/*滚动条整体样式*/
                width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
                height: 1px;
              }
              .table::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                border-radius: 2px;
                -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
                background: #dddddd;
              }
              .table::-webkit-scrollbar-track {/*滚动条里面轨道*/
                -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
                border-radius: 2px;
                background: #f5f5f5;
              }
            }
          }
        }
      }
    }
  }
  .tree_container1{
    padding-bottom: 20px;
    max-height: 500px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/page/systemManger/permissions.vue